import React, { useEffect, useState, useCallback } from 'react';
import axios from 'axios';
import { Container, Row, Col } from 'react-bootstrap';

import sectionGreyBg from '../../assets/images/section-top.webp';
import sectionBg from '../../assets/images/section-bg2.webp';
import Skeleton from '../../components/skeleton/Skeleton';
import { API_ENDPOINTS } from '../../utils/config';

const My3eSection = () => {
    const [my3eData, setMy3eData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [hasError, setHasError] = useState(false);

    const fetchMy3eData = useCallback(async () => {
        setIsLoading(true);
        setHasError(false);

        try {
            const response = await axios.get(API_ENDPOINTS.THREEES_ENDPOINT, {
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                },
            });

            setMy3eData(response.data || []);
        } catch (error) {
            console.error('Failed to fetch My3E data:', error);
            setHasError(true);
        } finally {
            setIsLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchMy3eData();
    }, [fetchMy3eData]);

    const renderContent = () => {
        if (isLoading) {
            return <Skeleton type="3es" />;
        }

        if (hasError) {
            return <p className="text-danger">Unable to load data. Please try again later.</p>;
        }

        if (!my3eData.length) {
            return <p className="text-light">No data available.</p>;
        }

        return my3eData.map(({ id, image_url, title, excerpt }) => (
            <div className="call-out" key={id}>
                <div className="call-out-image">
                    <img src={image_url} alt={title} loading="lazy" />
                </div>
                <div className="link">{title}</div>
                <p className="desc text-3">{excerpt}</p>
            </div>
        ));
    };

    return (
        <section
            id="my-3e"
            className="section bg-dark-blue"
            style={{ backgroundImage: `url(${sectionBg})` }}
        >
            <div
                className="section-decoration top"
                style={{ backgroundImage: `url(${sectionGreyBg})`, height: '35px' }}
            />

            <Container>
                <div className="position-relative d-flex text-center mb-5">
                    <h2 className="text-22 text-light opacity-4 text-uppercase fw-600 w-100 mb-0 font-primary wow fadeInUp">
                        Summary
                    </h2>
                    <p className="text-10 text-dark fw-600 position-absolute w-100 align-self-center font-secondary lh-base mb-0 wow fadeInUp">
                        My 3E's
                    </p>
                </div>

                <Row className="g-5">
                    <Col lg={12} className="text-center text-lg-start wow fadeInUp">
                        <div className="call-outs">{renderContent()}</div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
};

export default My3eSection;
